import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var CuratorFinder = function CuratorFinder(context) {
  var _this = this;

  _classCallCheck(this, CuratorFinder);

  _defineProperty(this, "search", function (params) {
    return _this.context.http.get("/msvc/v1/userprofiles/resolution/autocomplete/Userprofile_2000252?text=".concat(params));
  });

  this.context = context;
} // Userprofile_2000252 - is a WAG for curators
;

export default CuratorFinder;